<template>
  <div>
    <div class="g-tab-warp">
      <div class="tab-bar-goback" @touchstart="goBack" />
      <!-- staticNavName: 控制只显示nav -->
      <ul v-if="!staticNavName" class="tab-bar clearfix">
        <li
          v-for="(nav, index) in navList"
          :key="index"
          :class="{
            pre: nav.targetRouterName === currentItem.targetRouterName,
          }"
        >
          <nav-replace-link-item :nav="nav" />
        </li>
      </ul>
      <!-- 标题 -->
      <p v-if="staticNavName" class="title-style tab-bar clearfix">
        {{ staticNavName }}
      </p>
    </div>
  </div>
</template>

<script>
import NavReplaceLinkItem from './components/NavReplaceLinkItem';
import backHandle from '@/utils/core/backHandle.ts';

export default {
  components: { NavReplaceLinkItem },
  props: {
    staticNavName: {
      type: String,
      default: '',
    },
    navList: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentItem: {
      type: Object,
      required: true,
      default: () => ({ targetRouterName: '' }),
    },
  },
  data() {
    return {
      state: false,
    };
  },
  mounted() {},
  created() {},
  methods: {
    change() {
      if (this.state) {
        document.querySelector('#g-layer').classList.remove('right');
        this.state = false;
      } else {
        document.querySelector('#g-layer').classList.add('right');
        this.state = true;
      }
    },
    goBack() {
      this.$router.go(-1);
      // backHandle();
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-bar-goback {
  height: 0.47rem;
  width: 0.47rem;
  background: url(~@img/back.png) no-repeat;
  background-size: cover;
  display: block;
  margin-right: 0.24rem;
}

.g-tab-warp {
  height: 0.62rem;
  display: flex;
  justify-content: space-between;
  background: url(~@img/all_tit.png) no-repeat left bottom;
  position: relative;
  align-items: center;
  padding-left: 0.24rem;
  box-sizing: border-box;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .tab-bar li {
    margin: 0;
    width: 1.56rem;
    height: 0.62rem;
    line-height: 0.62rem;
    padding: 0;
    box-sizing: border-box;
  }

  .tab-bar /deep/ .nav-link-item {
    display: block;
    height: 100%;
    text-align: center;
    padding: 0;
    line-height: 0.62rem;
    font-family: fangzheng;
    font-weight: normal;
  }

  .tab-bar li.pre {
    background: url(~@img/be_tit.png) no-repeat;
    background-size: cover;
  }

  .tab-bar li.pre /deep/ .nav-link-item::after {
    background: #fff;
  }

  .tab-bar li.pre /deep/ .nav-link-item {
    padding: 0;
  }

  .title-style {
    width: calc(100% - 0.85rem);
    font-size: 0.26rem;
    color: #fff;
    padding-left: 0.2rem;
    box-sizing: border-box;
    text-align: center;
  }

  .more {
    width: 0.27rem;
    height: 0.24rem;
    padding: 0 0.2rem;

    a {
      display: block;
      width: 0.27rem;
      height: 0.27rem;
      margin-top: 0.24rem;
      background: url(~@img/icon/menu-search.png) no-repeat;
      background-size: 2rem 0.8rem;
      background-position: 0 -0.56rem;
      position: relative;
    }
  }
}
</style>
